import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const Clock = (properties: iconType) => (
  <SvgIcon {...properties} viewBox="0 0 23 23" style={{ fill: 'none', stroke: '#78869E' }}>
    <path d="M11.5 22C17.299 22 22 17.299 22 11.5C22 5.70101 17.299 1 11.5 1C5.70101 1 1 5.70101 1 11.5C1 17.299 5.70101 22 11.5 22Z" />
    <path d="M16.978 16.9783L12.4648 12.467" />
    <path d="M11.5004 12.8696C12.2567 12.8696 12.8699 12.2564 12.8699 11.5C12.8699 10.7436 12.2567 10.1304 11.5004 10.1304C10.744 10.1304 10.1309 10.7436 10.1309 11.5C10.1309 12.2564 10.744 12.8696 11.5004 12.8696Z" />
    <path d="M11.0439 6.47826V10.2062" />
  </SvgIcon>
);

Clock.defaultProperties = {
  strokeMiterlimit: '10',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  stroke: '#78869E',
};

export default Clock;
